import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Stack, Typography } from "@mui/material";

import NewsFeedContainer from "../../components/newsfeed-container";
import { ContentLayout } from "../../layout/contentLayout";

import { NewsfeedProps } from "../../interface/newsfeed";
import { apiGetNewsfeed } from "../../api/newsfeed";
import { SkeletonLoading } from "../../components/ui-elements/skeleton-loading";
import Search from "../../components/ui-elements/search";
import useInfiniteScrollRequest from "../../hooks/useInifiniteScrollRequest";

const Newsfeed: React.FC = () => {
  const theme = useTheme();

  // const { items, sentryRef, loading, updateParams, refetch } =
  //   useInfiniteScrollRequest<NewsfeedProps>({
  //     fetchData: apiGetNewsfeed,
  //     initialParams: { page: 1, page_size: 10, search: "" },
  //   });

  const { items, sentryRef, loading, updateParams } =
    useInfiniteScrollRequest<NewsfeedProps>({
      queryKey: "newsfeed",
      fetchData: apiGetNewsfeed,
      initialParams: {
        page_size: 10,
        search: "",
        state: "",
        local_government: "",
        position: "",
        sort_by: "",
        sort_order: "",
      },
    });
  const submit = (search: string) => {
    updateParams({ search: search });
    //
  };
  
  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header scrollContainerId="main-news-scroll-container">
          <Stack
            direction={"row"}
            spacing={4}
            sx={{ mt: 2 }}
            alignItems={"center"}
          >
            <Typography variant="h4" sx={{ fontWeight: 500 }}>
              Newsfeeds
            </Typography>
            <Search placeholder="Search" submit={submit} />
          </Stack>
        </Header>
        <ContentLayout>
          <Box
            id="main-news-scroll-container"
            sx={{
              maxWidth: 560,
              mx: "auto",
              py: "80px",
              height: "76vh",
              overflowY: "auto",
            }}
          >
            {loading && items?.length === 0 && (
              <Box sx={{}}>
                {[...Array(3)].map((_, idx) => (
                  <SkeletonLoading key={idx} />
                ))}
              </Box>
            )}
            {!loading && items?.length === 0 && (
              <Box sx={{ height: 300 }}>
                <Typography variant="h5" color="black" sx={{ fontWeight: 500, textAlign: 'center' }}>
                  No Data available
                </Typography>
              </Box>
            )}
            {items?.map((item, index) => (
              <NewsFeedContainer
                key={item?.report_id}
                report_id={item?.report_id}
                entity_value={item?.entity_value}
                place_admin_level={item?.place_admin_level}
                place_geocode_name={item?.place_geocode_name}
                report_title={item?.report_title}
                report_content={item?.report_content}
                report_url={item?.report_url}
                report_date_published={item?.report_date_published}
                source_name={item?.source_name}
                source_type_name={item?.source_type_name}
                post_type={item?.post_type}
                author={item?.author}
                author_id={item?.author_id}
                incident_type={item?.incident_type}
              />
            ))}
          </Box>

          <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
            {loading && (
              <Box sx={{}}>
                <SkeletonLoading />
              </Box>
            )}
          </div>
        </ContentLayout>
      </Box>
    </>
  );
};

export default Newsfeed;
